
const baseconfig = require('../../baseconfig')

export function setToken(token) {
    return localStorage.setItem("token-" + baseconfig.module,token)
}

export function getToken() {
    return localStorage.getItem("token-" + baseconfig.module)
}

export function IsValidateMobile() {
    let time = localStorage.getItem("is-validate-mobile-time")
    if(time > new Date().getTime() && localStorage.getItem("is-validate-mobile")) {
        return true;
    }
    return false
}

export function hideMobile(tel) { 
    var reg = /^(\d{3})\d{4}(\d{4})$/;
    return tel.replace(reg, "$1****$2")
 }; 


 export function LoginOut() {
    setToken("")
    localStorage.setItem("vuex","")
}